// @ts-strict-ignore
import styled from "styled-components";

import { Heading5, Paragraph3 } from "components/parts/Typography/cryptopedia";
import Picture from "components/parts/Picture";

export const PostTitle = styled(Heading5)`
  font-size: 20px;
  margin-top: 0;
  margin-bottom: 0;
  ${(props) => props.active && `text-decoration: underline`}
`;

export const PostSubtitle = styled(Paragraph3)`
  margin-top: 8px;
`;

export const PostContainer = styled.div`
  img {
    height: auto;
    width: 100%;
  }

  ${({ theme: { media } }) => media.tablet`
    padding-right: 32px;
  `}
`;

export const PostImage = styled(Picture)`
  img {
    padding-right: 16px;
    width: 100%;
  }
`;

export const CryptopediaPostContainer = styled.div`
  margin: 32px 0;
`;
